import moment from "moment";
import { clone } from "../../utils";

export function castInterventionFromDb(intervention) {
    let newIntervention = clone(intervention);
    newIntervention.date_planned_start = moment(newIntervention.date_planned_start);
    return intervention;
}

export function adaptInterventionForMyOpen(intervention) {
    let newIntervention = clone(intervention);
    newIntervention.date_planned_start = moment(
        moment.utc(newIntervention.date_planned_start, "YYYY-MM-DD HH:mm:ss").local()
    );
    newIntervention.equipment_description = "";
    newIntervention.failure_description = "";

    if (newIntervention.lines.length > 0) {
        newIntervention.equipment_description = newIntervention.lines[0].equipment_description;
        newIntervention.failure_description = newIntervention.lines[0].failure_description;
    }

    return newIntervention;
}

export function adaptInterventionForOpenERP(intervention) {
    let clonedIntervention = clone(intervention);

    return clonedIntervention;
}

export function adaptAttachmentForMyOpen(attachment) {
    let clonedAttachment = clone(attachment);

    return clonedAttachment;
}
